import { Box } from '@zillow/constellation-10';

import { AppSelectors } from '../../selectors';
import { useSelector } from '../../selectors/useSelector';

import { StyledIconBulb } from './StyledComponents';

const getAriaDescribedBy = (fieldName: string): string | undefined =>
  fieldName ? `learn-more-about-${fieldName}` : undefined;

type Props = {
  onClick: () => void;
  removeFlex?: boolean;
  fieldName?: string;
  dataEventid?: string;
};

const RecommendationIconBulb = ({ onClick, removeFlex = false, fieldName = '', dataEventid = '' }: Props) => {
  const isScreenLgGTE = useSelector((state) => AppSelectors.makeIsScreenLgGTE(state));

  if (removeFlex) {
    return (
      <StyledIconBulb
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        fontColor="brand"
        marginRight="xs"
        size="xs"
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </StyledIconBulb>
    );
  }

  return (
    <Box css={{ display: 'flex' }}>
      <StyledIconBulb
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        fontColor="brand"
        marginRight="xs"
        size="sm"
        marginLeft={isScreenLgGTE ? -4 : 0}
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </StyledIconBulb>
    </Box>
  );
};

export default RecommendationIconBulb;
